

import state from './moduleSubServicesState.js'
import mutations from './moduleSubServicesMutations.js'
import actions from './moduleSubServicesActions.js'
import getters from './moduleSubServicesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

